import apiClient from './authService';

export const providerService = {
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.category) params.append('category', filters.category);
    if (filters.status) params.append('status', filters.status);
    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await apiClient.get(`/api/providers${query}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/api/providers/${id}`);
    return response.data;
  },

  create: async (providerData) => {
    const response = await apiClient.post('/api/providers', providerData);
    return response.data;
  },

  update: async (id, providerData) => {
    const response = await apiClient.put(`/api/providers/${id}`, providerData);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/api/providers/${id}`);
    return response.data;
  },

  getShared: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.category) params.append('category', filters.category);
    if (filters.radius) params.append('radius', filters.radius);
    const query = params.toString() ? `?${params.toString()}` : '';
    const response = await apiClient.get(`/api/providers/shared${query}`);
    return response.data;
  },

  shareToggle: async (id, isShared) => {
    const response = await apiClient.patch(`/api/providers/${id}/share`, { isShared });
    return response.data;
  },

  cloneProvider: async (id) => {
    const response = await apiClient.post(`/api/providers/${id}/clone`);
    return response.data;
  }
};
